import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { GlobalStyles } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, useSearchParams } from 'react-router-dom';
import theme from './theme';
import HomePage from './components/HomePage';
import OrderForm from './components/OrderForm';
import SuccessPage from './pages/OrderResult/SuccessPage';
import FailurePage from './pages/OrderResult/FailurePage';
import ReviewsPage from './pages/ReviewsPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          'html, body, #root': {
            width: '100%',
            margin: 0,
            padding: 0,
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
          }
        }}
      />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/order" element={<OrderForm />} />
          <Route path="/order/success" element={<SuccessPage />} />
          <Route path="/order/failed" element={<FailurePage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
